import CONSTANTS from '../constants';
import OrderService from '../services/OrderService';
import { alerts } from './Alerts';

export function createOrder(
  userId,
  locationData,
  qrData,
  qrCodeData,
  cartData,
  orderData,
  paymentData = null,
  savyour
) {
  return async (dispatch) => {
    try {
      let order = await OrderService.createOrder(
        userId,
        locationData,
        qrData,
        qrCodeData,
        cartData,
        orderData,
        paymentData,
        savyour
      );
      dispatch({ type: CONSTANTS.ACTIONS.ORDERS.CREATE, order });
    } catch (error) {
      dispatch(alerts.error('ORDER_ERROR', error.message));
      console.log(error);
    }
  };
}

export function getOrders(userId, locationId) {
  return async (dispatch) => {
    try {
      let orders = await OrderService.getOrders(userId, locationId);
      if (orders && orders.data) {
        dispatch({
          type: CONSTANTS.ACTIONS.ORDERS.STATUS,
          orders: orders.data,
          orderTimes: orders.order_time_array
        });
      }
    } catch (error) {
      dispatch({ type: CONSTANTS.ACTIONS.ORDERS.STATUS, orders: [], orderTimes: [] });
      console.log(error);
    }
  };
}

export function getOrder(userId, locationId, orderId) {
  return async (dispatch) => {
    try {
      let order = await OrderService.getOrder(userId, locationId, orderId);
      if (order && order.data) {
        dispatch({
          type: CONSTANTS.ACTIONS.ORDERS.ORDER,
          order: order.data,
        });
      }
    } catch (error) {
      dispatch({ type: CONSTANTS.ACTIONS.ORDERS.ORDER, order: {} });
      console.log(error);
    }
  };
}

export function getMyOrders(userId, locationId) {
  return async (dispatch) => {
    try {
      let orders = await OrderService.getMyOrders(userId, locationId);
      dispatch({ type: CONSTANTS.ACTIONS.ORDERS.STATUS, orders: orders, orderTimes: [] });
    } catch (error) {
      dispatch({ type: CONSTANTS.ACTIONS.ORDERS.STATUS, orders: [], orderTimes: [] });
      console.log(error);
    }
  };
}

export function clearOrder() {
  return async (dispatch) => {
    try {
      dispatch({ type: CONSTANTS.ACTIONS.ORDERS.CREATE, order: null });
    } catch (error) {
      console.log(error);
    }
  };
}
